<template>
  <div class="historic-records">
    <div class="history-main" v-loading="loading">
      <div class="history-card">
        <div class="history-title flex items-center justify-between">
          <span>历史记录</span>
          <el-select v-model="currentValue" placeholder="请选择" style="width: 150px" @change="handleTypeChange">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-empty v-if="!historyData || !historyData.length" />
        <div class="history-item flex items-start" v-for="(item,i) in historyData" :key="i" v-else>
          <div class="item-text flex items-center justify-between">
            <div class="flex items-center" style="width: calc(100% - 177px);flex-shrink: 0">
              <span class="icon">
                <img :src="require('@/assets/images/common/achievement-icon.png')" alt="" v-if="item.type === 'achievement'">
                <img :src="require('@/assets/images/common/demand-icon.png')" alt="" v-else-if="item.type === 'demand'">
                <img :src="require('@/assets/images/achievement/history-icon.png')" alt="" v-else>
              </span>
              <p class="text ellipsis">
                <span @click="toDetails(item)" :title="item.title">{{ item.title || '-' }}</span>
              </p>
            </div>
            <span class="item-time no-wrap">{{ item.createdTime ? formatToDateTime(item.createdTime) : '-' }}</span>
            <span class="delete pointer" @click="handleDelete(item)">
              <img :src="require('@/assets/images/achievement/history-delete.png')" alt="">
            </span>
          </div>
        </div>
      </div>
      <div class="page-container" v-if="pager.total">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pager.pageNum"
          :page-size="pager.pageSize"
          layout="prev, pager, next"
          :total="pager.total"
        />
      </div>
    </div>
    <!--  确认删除按钮  -->
    <delete-confirm
      :visible.sync="deleteVisible"
      @confirm="handleDeleteConfirm"
      title="提示"
      :message="'删除后，该记录不可恢复。确认删除吗？'"
    />
  </div>
</template>

<script>
import deleteConfirm from '@/components/deleteConfirm.vue';
import { historicRecordsMixin } from '@/mixin/historicRecords/historicRecordsMixin';

export default {
  name: 'historicRecords',
  mixins: [ historicRecordsMixin ],
  components: {
    deleteConfirm
  },
  props: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    disabled () {
      return this.loading || this.noMore
    },
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.historic-records {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px);
  background: linear-gradient(60.33deg, rgba(207, 234, 255, 0.4) 9%, rgba(227, 227, 255, 0.4) 46%, rgba(192, 223, 255, 0.4) 88%);
  .history-main {
    width: 1080px;
    padding: 20px 0 0;
    margin: 0 auto;
    .history-card {
      min-height: 400px;
      padding-bottom: 40px;
      border-radius: 12px;
      background: #fff;
      .history-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        padding: 24px 30px 14px;
        border-bottom: 1px solid #F2F5F9;
        margin-bottom: 14px;
      }
      .history-item {
        margin: 0 30px;
        border-bottom: 1px solid #F2F5F9;
        .item-text {
          width: 100%;
          flex-shrink: 0;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 16px;
          padding: 20px 0;
          .icon {
            width: 14px;
            height: 16px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            padding-right: 24px;
            img {
              width: 14px;
              height: 14px;
            }
            .icon-marker {
              flex-shrink: 0;
              width: 14px;
              height: 14px;
              line-height: 14px;
              text-align: center;
              border: 1px solid #eee;
              border-radius: 4px;
              color: #eee;
              font-size: 10px;
            }
          }
          .text {
            width: calc(100% - 38px);
            flex-shrink: 0;
            display: inline-block;
            color: #000000;
            span {
              cursor: pointer;
            }
          }
        }
        .item-time {
          flex-shrink: 0;
          width: 125px;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          padding-left: 15px;
        }
        .delete {
          display: flex;
          align-items: center;
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          margin-left: 20px;
          img {
            width: 13px;
            height: 13px;
          }
        }
      }
    }

    .page-container {
      text-align: center;
      padding: 20px 0;

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1241C9;
        color: #ffffff;
      }
      /deep/ .el-pagination.is-background .el-pager li {
        border-radius: 4px;
        background-color: #ffffff;
        min-width: 30px;
        height: 28px;
        color: #333333;
        line-height: 28px;
      }
      /deep/ .el-pagination.is-background {
        .btn-next {
          height: 28px;
          line-height: 28px;
          border-radius: 4px;
          background-color: #ffffff;
          .el-icon-arrow-right:before {
            content: '\e791';
          }
        }

        .btn-prev {
          height: 28px;
          line-height: 28px;
          border-radius: 4px;
          background-color: #ffffff;
          .el-icon-arrow-left:before {
            content: '\e792';
          }
        }
      }
    }

    .load-tip {
      text-align: center;
      padding: 20px;
      font-size: 14px;
      color: #777777;
    }
  }
}
</style>
